/* eslint-disable no-param-reassign */
import { useRouter } from "next/router"
import { useRef } from "react"
import { SwiperSlide } from "swiper/react"
import { Card } from "@components/anti/Card"
import Link from "@components/anti/Link"
import { SliderSwiper } from "@components/anti/Slider/Swiper"
import { translations } from "src/helper/translations"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import SwiperNavigation from "../SwiperNavigation"

function SectionWithSlider({
  link,
  data,
  text,
  title,
  linkText,
  hasArrow,
  sectionName,
  textClassName,
  navTheme = "dark",
  cardType = "overlay",
  cardRatio = "r-4-3",
  slidesPerViewMobile,
  slidesPerViewDesktop,
  linkCardWithButton,
  dataLayer,
}) {
  const [trigger, anim] = useScrollAnim("fadeInUp", [0.125, 0.5, 0.75])
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  const router = useRouter()

  return (
    <section
      className={`sc-with-slider ${sectionName} ${
        linkCardWithButton ? "link-card-with-button" : ""
      }`}
      ref={trigger}
    >
      <div className="py-main">
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-text">
              <div className="content-text">
                <h2 className={`title ${anim(1)}`}>{title}</h2>
                <div
                  className={`text ${textClassName} ${anim(2, "fadeInUp8")}`}
                >
                  {text}
                </div>
                {link ? (
                  <Link href={link} withArrow className={anim(3)}>
                    {linkText}
                  </Link>
                ) : null}
              </div>
              {hasArrow ? (
                <SwiperNavigation
                  theme={navTheme}
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                />
              ) : null}
            </div>
            <div className="col-sm-8 col-slider">
              <div className="slider-wrapper">
                <SliderSwiper
                  swiperRef={swiperRef}
                  breakpoints={{
                    365: {
                      slidesPerView: slidesPerViewMobile,
                      spaceBetween: 20,
                    },
                    768: {
                      slidesPerView: slidesPerViewDesktop,
                      spaceBetween: 20,
                    },
                  }}
                  slidesPerView={slidesPerViewMobile}
                  className={`${sectionName}__slider`}
                >
                  {data?.map((item, i) => (
                    <SwiperSlide
                      key={`${sectionName}__slider-item${i}`}
                      className={`${sectionName}__slider-item`}
                    >
                      <div
                        onClick={() => {
                          if (dataLayer) {
                            dataLayer(item)
                          }
                        }}
                        role="presentation"
                      >
                        <Card
                          link={item.link || item.linkCard}
                          variant={cardType}
                          imgRatio={cardRatio}
                          imgOverlay={cardType === "overlay" ? "50" : null}
                          title={item.title}
                          text={item.text}
                          tags={item.tags}
                          textClassName="mb-0"
                          img={item.img}
                          imgAlt={`img-${sectionName}`}
                          className={`${sectionName}__card ${anim(i + 3)}`}
                          titleClassName="text-truncate-twoline mb-2"
                        >
                          {item.link ? (
                            <div
                              // onClick={() => router.push(item.link)}
                              className="link-card text-white"
                              role="button"
                              tabIndex={0}
                            >
                              {item.linkText ??
                                translations[
                                  `learn_more_${router.locale}`
                                ]}{" "}
                              <span className="air ai-arrow-right" />
                            </div>
                          ) : null}
                          {linkCardWithButton ? (
                            <div className="rounded-button">
                              <i className="cxi-arrow-right" />
                            </div>
                          ) : null}
                        </Card>
                      </div>
                    </SwiperSlide>
                  ))}
                </SliderSwiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SectionWithSlider
